import { render, staticRenderFns } from "./Nextstrain.vue?vue&type=template&id=76816012&scoped=true"
import script from "./Nextstrain.vue?vue&type=script&lang=js"
export * from "./Nextstrain.vue?vue&type=script&lang=js"
import style0 from "./Nextstrain.vue?vue&type=style&index=0&id=76816012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76816012",
  null
  
)

export default component.exports